import React from 'react';
import PropTypes from 'prop-types';
import * as ReactDropdownMenu from '@radix-ui/react-dropdown-menu';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import './DropdownMenu.scss';

function DropdownMenu({ title, options, icon, withCheckboxes, withIcons, buttonTestId, id }) {

  const renderOption = (option, idx) => (
    <ReactDropdownMenu.Item
      key={option.label || idx}
      className={`addMenu-menuItem ${option.highlighted ? 'highlighted' : ''} ${withCheckboxes || withIcons ? 'with-checkbox' : ''}`}
      onSelect={option.onSelect}
      disabled={option.disabled}
      data-testid={`dropdown-menu-item-[${option.label && typeof option.label === 'string' ? option.label.replace(/\s+/g, '-').toLowerCase() : idx}]`}
    >
      {withCheckboxes && (
        <input
          type="checkbox"
          className="filter-label"
          checked={option.checked}
          disabled={option.disabled}
          readOnly
        />
      )}
      <div
        data-tooltip-content={option.tooltip}
        data-tooltip-id="tooltip"
      >
        {option.label}
      </div>
    </ReactDropdownMenu.Item>
  );

  return (
    <ReactDropdownMenu.Root 
      modal={false}
    >
      <ReactDropdownMenu.Trigger asChild>
        <button
          type="button"
          className={`addMenu-button ${id || ''} ${icon ? `with-icon ${icon}-container` : ''}`}
          aria-label={title}
          data-testid={buttonTestId || 'dropdown-menu-button'}
        >
          {icon ? <div className={`icon ${icon}`} /> : title}
        </button>
      </ReactDropdownMenu.Trigger>

      <ReactDropdownMenu.Portal style={{ zIndex: 100 }}>
        <ReactDropdownMenu.Content 
          className={`addMenu-menu ${id || ''}`} 
          align="end"
          sideOffset={4}
          collisionPadding={8}
        >
          {options.filter(option => option.subMenu).map((option, idx) => {
            return (
              <ReactDropdownMenu.Sub key={option.label || idx}>
                <ReactDropdownMenu.SubTrigger 
                  className="addMenu-menuItem submenu-trigger"
                  data-testid={`submenu-trigger-[${option.label && typeof option.label === 'string' ? option.label.replace(/\s+/g, '-').toLowerCase() : idx}]`}
                >
                  <div className="arrow" />
                  {option.label}
                </ReactDropdownMenu.SubTrigger>
                <ReactDropdownMenu.Portal>
                  <ReactDropdownMenu.SubContent 
                    className={`addMenu-menu ${id || ''} submenu-content`}
                    align="start"
                    sideOffset={2}
                    collisionPadding={8}
                    data-testid={`submenu-content-[${option.label && typeof option.label === 'string' ? option.label.replace(/\s+/g, '-').toLowerCase() : idx}]`}
                  >
                    <OverlayScrollbarsComponent
                      defer
                      options={{ scrollbars: { autoHide: 'leave', autoHideDelay: '100' } }}
                      style={{ maxHeight: '80vh', paddingRight: '5px' }}
                    >
                      {Array.isArray(option.subMenu) ? 
                        option.subMenu.map((subOption, subIdx) => 
                          renderOption(subOption, `${idx}-${subIdx}`)
                        ) : option.subMenu}
                    </OverlayScrollbarsComponent>
                  </ReactDropdownMenu.SubContent>
                </ReactDropdownMenu.Portal>
              </ReactDropdownMenu.Sub>
            );
           })}
          {options.filter(option => !option.subMenu).map((option, idx) => (
            renderOption(option, idx)
          ))}
        </ReactDropdownMenu.Content>
      </ReactDropdownMenu.Portal>
    </ReactDropdownMenu.Root>
  );
}
DropdownMenu.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onSelect: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      checked: PropTypes.bool,
    }),
  ).isRequired,
  icon: PropTypes.string,
  withCheckboxes: PropTypes.bool,
  withIcons: PropTypes.bool,
  buttonTestId: PropTypes.string,
};

export default DropdownMenu;
